/* eslint-disable @next/next/no-img-element */
import fromSocialOcean from "../assets/from-social-ocean.png";

export function FromSocialOcean({
  className = "tw:object-contain tw:block tw:w-20",
}: {
  className?: string;
}) {
  return <img src={fromSocialOcean} alt="From Instant Access" className={className} />;
}
